import { Component, OnInit } from '@angular/core';
import { ApiService } from "../../services/api.service";

@Component({
  selector: 'app-menu-conciliacion',
  templateUrl: './menu-conciliacion.page.html',
  styleUrls: ['./menu-conciliacion.page.scss'],
})
export class MenuConciliacionPage implements OnInit {

  constructor(
    public api:ApiService
  ) { }

  ngOnInit() {
  }

}
